import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "../../guards/auth.guard";
import { AccessibilityStatementComponent } from "./accessibility-statement.component";

const routes: Routes = [
    {
        path: 'accessibilityStatement',
        component: AccessibilityStatementComponent,
        canLoad: [AuthGuard],
    }
]
@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AccessibilityStatementRoutingModule {}